export function bundleThumbnail() {
  return ({ bundleDisplayData }) => {
    const { data } = bundleDisplayData.find(({ language }) => language === "English");

    return data.thumbnailUrl;
  };
};
